'use strict';

import template from './popover';

const saPopover = [
  '$window',

  function ($window) {
    return {
      restrict: 'E',
      replace: true,
      transclude: true,
      template: template,
      link: function ($scope, $element) {
        var body = angular.element($element.children()[1]);

        $element.css({
          position: 'relative'
        });

        function bindHide() {
          angular.element($window).on('click', hidePopover);
          angular.element($window).on('resize', hidePopover);
        }

        function unbindHide() {
          angular.element($window).off('click', hidePopover);
          angular.element($window).off('resize', hidePopover);
        }

        function bindShow() {
          $element.on('click', showPopover);
        }

        function unbindShow() {
          $element.off('click', showPopover);
        }

        function showPopover(e) {
          e.stopPropagation();

          body.css('display', 'block');
          bindHide();
          unbindShow();
        }

        function hidePopover() {
          body.css('display', 'none');
          bindShow();
          unbindHide();
        }

        hidePopover();

        $scope.$on('$destroy', unbindHide);
      }
    };
  }
];

export default saPopover;



// WEBPACK FOOTER //
// ./app/src/directives/popover.js